<div class="header">
  <div class="title">{{ dynamicDialogTitle }}</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form #fieldForm [formGroup]="updateCustomFieldForm" class="field-dialog-form">
  <!-- Related to Type -->
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto treo-mat-no-subscript">
      <mat-label>Object Type</mat-label>
      <mat-select [formControlName]="'related_to_type'">
        <mat-option [value]="'Project'">Deal</mat-option>
        <mat-option [value]="'PropertyTenant'">Lease</mat-option>
        <mat-option [value]="'Property'">Property</mat-option>
        <mat-option [value]="'PropertyUnit'">Unit</mat-option>
        <mat-option [value]="'Task'">Task</mat-option>
        <mat-option [value]="'LoanQuote'">Loan Quote</mat-option>
        <mat-option *ngIf="hasFacilityReportsEnabled$ | async" [value]="'FacilityReport'">Historical FOIA</mat-option>
        <mat-option [value]="'Contact'">Contact</mat-option>
        <mat-option [value]="'Company'">Company</mat-option>
        <mat-option [value]="'Offer'">Offer</mat-option>
        <!-- Custom Objects -->
        <ng-container *ngIf="hasCustomObjectsEnabled$ | async">
          <mat-option *ngFor="let customObject of customObjects; trackBy: trackByFn" [value]="customObject.name">{{
            customObject.label | titlecase
          }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Field Label -->
  <div class="flex flex-col gt-xs:flex-row mt-3">
    <mat-form-field class="subject flex-auto">
      <mat-label>Label</mat-label>
      <input data-cy="custom-field-name-input" matInput placeholder="Enter Field Name" [formControlName]="'label'" />
      <mat-hint *ngIf="updateCustomFieldForm.get('label').hasError('duplicateName')">
        Warning: A field with the same or similar name already exists.
      </mat-hint>
    </mat-form-field>
  </div>

  <div class="flex flex-col gt-xs:flex-row mt-3">
    <!-- Field Type -->
    <mat-form-field class="flex-auto treo-mat-no-subscript mb-4">
      <mat-label>Field Type</mat-label>
      <mat-select
        [formControlName]="'type'"
        data-cy="custom-field-type-select"
        [matTooltip]="'The field type cannot be modified because it is either a standard field or is used in values.'"
        [matTooltipDisabled]="!isFieldTypeDisabled"
      >
        <mat-option [value]="'checkbox'" [disabled]="!canChangeToFieldType('checkbox')">Checkbox</mat-option>
        <mat-option [value]="'money'" [disabled]="!canChangeToFieldType('money')">Currency</mat-option>
        <mat-option [value]="'date'" [disabled]="!canChangeToFieldType('date')">Date</mat-option>
        <mat-option *ngIf="data?.id" [value]="'datetime'" [disabled]="!canChangeToFieldType('datetime')"
          >Datetime</mat-option
        >
        <mat-option [value]="'decimal'" [disabled]="!canChangeToFieldType('decimal')">Decimal (1.00)</mat-option>
        <mat-option [value]="'number'" [disabled]="!canChangeToFieldType('checnumberkbox')">Number (1,000)</mat-option>
        <mat-option [value]="'percent'" [disabled]="!canChangeToFieldType('percent')">Percent</mat-option>
        <mat-option [value]="'record'" [disabled]="!canChangeToFieldType('record')">Related To</mat-option>
        <mat-option [value]="'select'" [disabled]="!canChangeToFieldType('select')">Select</mat-option>
        <mat-option [value]="'text'" [disabled]="!canChangeToFieldType('text')">Text</mat-option>
        <mat-option [value]="'textarea'" [disabled]="!canChangeToFieldType('textarea')">Text Area</mat-option>
        <mat-option [value]="'url'" [disabled]="!canChangeToFieldType('url')">Url</mat-option>
        <mat-option [value]="'year'" [disabled]="!canChangeToFieldType('year')">Year</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Record Type -->
    <div class="ml-3 row" *ngIf="updateCustomFieldForm?.get('type')?.value === 'record'">
      <mat-form-field class="field treo-mat-no-subscript">
        <mat-label>Record Type</mat-label>
        <mat-select [formControlName]="'record_type'">
          <mat-option [value]="'Company'">Company</mat-option>
          <mat-option [value]="'Contact'">Contact</mat-option>
          <mat-option [value]="'User'">User</mat-option>
          <mat-option [value]="'Property'">Property</mat-option>
          <mat-option [value]="'FileResource'">File</mat-option>
          <!-- Custom Objects -->
          <ng-container *ngIf="hasCustomObjectsEnabled$ | async">
            <mat-option *ngFor="let object of objects; trackBy: trackByFn" [value]="object.name">
              {{ object.label }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Dropdown values for fields of type select -->
  <ng-container *ngIf="isTypeSelectField && !isStandardField">
    <section
      formArrayName="options"
      class="dropdown-values"
      *ngIf="fieldUsageResult && !loadingFieldUsageResult; else loadingFieldUsageResultTemplate"
    >
      <section class="dropdown-values__actions">
        <span class="m-0">Dropdown Values</span>
        <button mat-stroked-button (click)="addDropDownValue()">
          <mat-icon [svgIcon]="'add'"></mat-icon> Add Dropdown
        </button>
      </section>
      <section
        class="dropdown-values__list"
        cdkDropList
        [cdkDropListData]="optionsFormArray.controls"
        (cdkDropListDropped)="drop($event)"
      >
        <table mat-table [dataSource]="dataSource" class="pt-0 w-full">
          <ng-container matColumnDef="drag">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let option; let i = index">
              <mat-icon
                cdkDragHandle
                [svgIcon]="'drag_indicator'"
                class="dropdown-values__item--drag-handle"
              ></mat-icon>
            </td>
          </ng-container>
          <ng-container matColumnDef="dropdown">
            <th class="text-left" mat-header-cell *matHeaderCellDef>OPTION</th>
            <td class="text-lg" mat-cell *matCellDef="let option; let i = index">
              <mat-form-field class="w-full pt-2 -mb-6">
                <input
                  #inputOptions
                  class="dropdown-values__item--input"
                  [ngClass]="{ 'not-allowed': !optionsFormArray.at(i)['isNewOption'] }"
                  matInput
                  [formControl]="optionsFormArray.at(i)"
                  [value]="optionsFormArray.at(i)?.value"
                  [autocomplete]="false"
                  [readonly]="!optionsFormArray.at(i)['isNewOption']"
                />
              </mat-form-field>
            </td>
          </ng-container>
          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef>
              <div class="w-full flex justify-center items-center">
                WITH VALUE
                <mat-icon [svgIcon]="'info'" [matTooltip]="'Number of records using this value'"></mat-icon>
              </div>
            </th>
            <td class="text-center" mat-cell *matCellDef="let option; let i = index">
              <div class="truncate">
                <span [matTooltip]="option.property_type?.name">{{ getUsageFieldsValue(option.value) }}</span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <div class="text-center">ACTIONS</div>
            </th>
            <td mat-cell *matCellDef="let option; let i = index">
              <div class="w-full flex justify-center items-center">
                <button
                  mat-icon-button
                  (click)="editDropDownValue(i)"
                  [disabled]="!canEditOrDeleteDropDownOption(i)"
                  [matTooltip]="
                    !canEditOrDeleteDropDownOption(i)
                      ? 'You must first disassociate an option to be able to edit its value'
                      : 'Edit option value'
                  "
                >
                  <mat-icon [svgIcon]="'edit'"></mat-icon>
                </button>
                <button
                  mat-icon-button
                  (click)="removeDropDownValue(i)"
                  [disabled]="!canEditOrDeleteDropDownOption(i)"
                  [matTooltip]="
                    !canEditOrDeleteDropDownOption(i)
                      ? 'You must first disassociate an option to be able to delete its value'
                      : 'Delete option'
                  "
                >
                  <mat-icon [svgIcon]="'delete'"></mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="rowDef"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: rowDef"
            class="py-2"
            cdkDrag
            cdkDragLockAxis="y"
            cdkDragBoundary=".dropdown-values__list"
            cdkDragHandle
          ></tr>
        </table>
        <ng-container *ngIf="isSelectDropDownListEmpty">
          <section class="dropdown-values__list--empty w-full p-4">
            <p class="text-center">No values added so far.</p>
            <p class="text-center">Click on the button above to start adding new values.</p>
          </section>
        </ng-container>
      </section>
    </section>

    <!-- Multi-select -->
    <div class="flex flex-col gt-xs:flex-row mt-2 mb-3">
      <mat-checkbox [color]="'primary'" [formControlName]="'multi_select'">
        <span>Multi Select</span>
      </mat-checkbox>
    </div>

    <!-- Allow non-admins to edit fields of type select -->
    <div class="flex flex-col gt-xs:flex-row mb-3">
      <mat-checkbox [color]="'primary'" [formControlName]="'user_editable'">
        <span>Allow non-admins to edit selection options</span>
      </mat-checkbox>
    </div>
  </ng-container>

  <!-- Precision select if field is numerical -->
  <ng-container *ngIf="enablePrecision()">
    <div class="flex flex-col gt-xs:flex-row mb-3">
      <mat-form-field class="flex-auto field treo-mat-no-subscript">
        <mat-label>Decimal Places</mat-label>
        <mat-select [formControlName]="'scale'" [value]>
          <mat-option [value]="0">0</mat-option>
          <mat-option [value]="1">1</mat-option>
          <mat-option [value]="2">2</mat-option>
          <mat-option *ngIf="!isMoney()" [value]="3">3</mat-option>
          <mat-option *ngIf="!isMoney()" [value]="4">4</mat-option>
          <mat-option *ngIf="!isMoney()" [value]="5">5</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <!-- Field Usage -->
  <section class="field-usage">
    <mat-tab-group #fieldUsageTabGroup mat-stretch-tabs mat-align-tabs="start" animationDuration="0ms">
      <mat-tab>
        <ng-template mat-tab-label>
          <p>Basic info</p>
        </ng-template>
        <section class="pt-4 w-full">
          <!-- Field Description -->
          <div class="flex flex-col gt-xs:flex-row">
            <mat-form-field class="flex-auto">
              <mat-label>Field Description</mat-label>
              <textarea
                class="leading-normal my-2 text-sm h-20"
                [formControlName]="'description'"
                [rows]="5"
                matInput
                [placeholder]="'Take some notes so that you know what this field is about.'"
                spellcheck="false"
              ></textarea>
            </mat-form-field>
          </div>

          <!-- Multi-select -->
          <div
            class="flex flex-col gt-xs:flex-row mt-2 mb-5"
            *ngIf="updateCustomFieldForm?.get('type')?.value === 'record'"
          >
            <mat-checkbox [color]="'primary'" [formControlName]="'multi_select'">
              <span>Multi Select</span>
            </mat-checkbox>
          </div>

          <!-- Field Hidden -->
          <div class="flex flex-col gt-xs:flex-row mb-5">
            <mat-checkbox [color]="'primary'" [formControlName]="'archived'">
              <span>Archive field</span>
            </mat-checkbox>
          </div>

          <!-- Field Readonly -->
          <ng-container *ngIf="!isStandardField">
            <div class="flex flex-col gt-xs:flex-row mb-5">
              <mat-checkbox [color]="'primary'" [formControlName]="'readonly'">
                <span>Make field readonly</span>
              </mat-checkbox>
            </div>
          </ng-container>

          <!-- Audit Log -->
          <div class="flex flex-col gt-xs:flex-row mb-5">
            <mat-checkbox color="primary" [formControlName]="'show_history'">
              <span>Show audit log</span>
            </mat-checkbox>
          </div>

          <!-- Inherited -->
          <ng-container *ngIf="data?.related_to_type === 'Deal'">
            <div class="flex flex-col gt-xs:flex-row mb-5">
              <mat-checkbox color="primary" [formControlName]="'inherited'">
                <span>Child deals inherit value</span>
              </mat-checkbox>
            </div>
          </ng-container>

          <!-- Default Value -->
          <ng-container *ngIf="updateCustomFieldForm?.get('type')?.value !== 'record'">
            <div class="flex flex-col gt-xs:flex-row">
              <mat-form-field class="flex-auto">
                <mat-label>Default Value</mat-label>
                <textarea
                  class="leading-normal my-2 text-sm h-20"
                  [mentionConfig]="mentionConfig"
                  matInput
                  cdkTextareaAutosize
                  [formControlName]="'default_calc_code'"
                  [rows]="5"
                  [placeholder]="'@ for functions and # for fields E.g. SUM( far, noi )'"
                  spellcheck="false"
                ></textarea>
              </mat-form-field>
            </div>
          </ng-container>

          <!-- Calc Code -->
          <div class="flex flex-col gt-xs:flex-row">
            <mat-form-field class="flex-auto">
              <mat-label>Calc Code</mat-label>
              <textarea
                class="leading-normal my-2 text-sm h-20"
                [mentionConfig]="mentionConfig"
                matInput
                cdkTextareaAutosize
                [formControlName]="'calc_code'"
                [rows]="5"
                [placeholder]="'@ for functions and # for fields E.g. SUM( far, noi )'"
                spellcheck="false"
              ></textarea>
              <button matSuffix mat-icon-button aria-label="AI Ability" (click)="openCalcCodeAIAbilityDialog()">
                <img src="assets/icons/ai-shine-stars-yellow.svg" alt="AI Ability" />
              </button>
            </mat-form-field>
          </div>
          <ng-container *ngIf="data.mode !== 'add'">
            <div class="flex flex-col gt-xs:flex-row">
              <mat-form-field class="flex-auto">
                <mat-label>Calc Index</mat-label>
                <input
                  matInput
                  [formControlName]="'calc_index'"
                  [placeholder]="'Higher calc indexes run before fields with lower calc indexes.'"
                />
              </mat-form-field>
            </div>
          </ng-container>
        </section>
      </mat-tab>
      <ng-container *ngIf="data.mode !== 'add'">
        <ng-container *ngIf="fieldUsageResult">
          <mat-tab>
            <ng-template mat-tab-label>
              <p>Used in ({{ fieldUsageResult?.values_count }})</p>
            </ng-template>
            <section class="field-usage__wrapper w-full">
              <article class="field-usage__wrapper--value-count">
                <ng-container
                  *ngIf="fieldUsageResult.values_count || fieldUsageResult.total_objects_count"
                  [ngPlural]="fieldUsageResult.values_count"
                >
                  <p class="mat-elevation-z4">
                    <ng-template ngPluralCase="=1">
                      <strong>{{ fieldUsageResult.values_count }}</strong> record out of
                      <strong>{{ fieldUsageResult.total_objects_count }}</strong> have a value for this field.
                    </ng-template>
                    <ng-template ngPluralCase="other">
                      <strong>{{ fieldUsageResult.values_count }}</strong> records out of
                      <strong>{{ fieldUsageResult.total_objects_count }}</strong> have a value for this field.
                    </ng-template>
                  </p>
                </ng-container>
              </article>
              <mat-divider></mat-divider>
              <ng-container *ngIf="fieldUsageResult.usages?.length">
                <table mat-table [dataSource]="fieldUsageResult.usages" class="w-full">
                  <ng-container matColumnDef="template_name">
                    <th mat-header-cell *matHeaderCellDef>Template</th>
                    <td mat-cell *matCellDef="let element">{{ element.used_by_name }}</td>
                  </ng-container>
                  <ng-container matColumnDef="template_type">
                    <th mat-header-cell *matHeaderCellDef>Template Type</th>
                    <td mat-cell *matCellDef="let element">{{ element.used_by_type }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
              </ng-container>
            </section>
          </mat-tab>
        </ng-container>
      </ng-container>
    </mat-tab-group>
  </section>

  <!-- Conditional Formatting -->
  <conditional-field-styling-form
    [fieldsDialogData]="fieldDataWithDropdownOptions"
    [accountColors]="accountColorOptions$ | async"
    (newStylingConditionAdded)="onStylingConditionAdded()"
    (conditionalStylingChanged)="onConditionalStylingChanged($event)"
  />
</form>

<!-- Dialog Form Actions -->
<section class="actions">
  <button class="discard-button" mat-button type="button" (click)="discard()">
    <span>Cancel</span>
  </button>
  <button
    data-cy="save-custom-field"
    class="send-button"
    mat-flat-button
    type="submit"
    [color]="'primary'"
    [disabled]="
      updateCustomFieldForm.pristine ||
      updateCustomFieldForm.invalid ||
      updateCustomFieldForm.disabled ||
      conditionalStylingInvalid()
    "
    (click)="save()"
  >
    <span *ngIf="!updateCustomFieldForm.disabled">Save</span>
    <mat-progress-spinner
      *ngIf="updateCustomFieldForm.disabled"
      [diameter]="24"
      [mode]="'indeterminate'"
    ></mat-progress-spinner>
  </button>
</section>

<ng-template #loadingFieldUsageResultTemplate>
  <div class="ph-col-12 mb-4" style="height: 250px">
    <div class="ph-row">
      <div class="ph-col-4 ml-2 big"></div>
      <div class="ph-col-4 ml-2 big"></div>
    </div>
    <div class="ph-row">
      <div class="ph-col-4 ml-2 big"></div>
      <div class="ph-col-4 ml-2 big"></div>
    </div>
    <div class="ph-row">
      <div class="ph-col-4 ml-2 big"></div>
      <div class="ph-col-4 ml-2 big"></div>
    </div>
  </div>
</ng-template>
